import './App.css';
import Header from './components/Header/Header';
import './index.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './Pages/Home/Home';
// import LabelCreating from './Pages/LabelCreating/LabelCreating';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import Footer from './components/Footer/Footer';
import Refund from './Pages/Refund/Refund';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import SignIn from './Pages/SignIn/SignIn';
import { currentUser, isAuthExpired, isAuthorized } from './utils/Auth/auth';
import ShipmentsInfo from './Pages/Shipments/ShipmentsInfo';
import Reports from './Pages/Reports/Reports';
import ChangeContainerBranch from './Pages/ChangeContainerBranch/ChangeContainerBranch';
import Administrators from './Pages/Administrators/Administrators';
import { userPermissions } from './constants/enums/Permissions';
//import ComingSoonPage from './Pages/ComingSoon/ComingSoonPage';
import AgentsMap from './Pages/AgentsMap/AgentsMap';
import Users from './Pages/Users/Users';
import ParcelRates from './Pages/ParcelRates/ParcelRates';
import CanParTracking from './Pages/CanParTracking/CanParTracking';
import OdooPortalSync from './Pages/Shipments/OdooPortalSync';

function App() {
  isAuthExpired();
  const swalModal = withReactContent(Swal);
  return (
    <Router>
      <div className="App min-w-[430px]">
        <Header />
        <div className="mt-[140px] min-h-[80vh] w-full overflow-x-none overflow-x-hidden">
          <Routes>
            <Route path="/" element={<Home />} />

            <Route path="/signIn" element={<SignIn />} />
            {isAuthorized ? (
              <>
                {currentUser?.canParTracking && (
                  <Route
                    path="/canParTracking"
                    element={<CanParTracking swalModal={swalModal} />}
                  />
                )}
                {currentUser?.shipments === userPermissions.write && (
                  <Route
                    path="/odooPortalSync"
                    element={<OdooPortalSync swalModal={swalModal} />}
                  />
                )}
                {(currentUser?.shipments === userPermissions.read ||
                  currentUser?.shipments === userPermissions.write) && (
                  <Route
                    path="/shipmentsinfo"
                    element={<ShipmentsInfo swalModal={swalModal} />}
                  />
                )}
                {currentUser?.refund && (
                  <Route
                    path="/refund"
                    element={<Refund swalModal={swalModal} />}
                  />
                )}
                {currentUser?.reports && (
                  <Route
                    path="/reports"
                    element={<Reports swalModal={swalModal} />}
                  />
                )}
                {currentUser?.containerBranchChange && (
                  <Route
                    path="/changeContainerBranch"
                    element={<ChangeContainerBranch swalModal={swalModal} />}
                  />
                )}
                {currentUser?.agentList && (
                  <Route
                    path="/agentList"
                    element={<AgentsMap swalModal={swalModal} />}
                  />
                )}
                {currentUser?.administrators && (
                  <Route
                    path="/admins"
                    element={<Administrators swalModal={swalModal} />}
                  />
                )}
                {currentUser?.userAccounts && (
                  <Route
                    path="/users"
                    element={<Users swalModal={swalModal} />}
                  />
                )}
                {(currentUser?.parcelRates === userPermissions.read ||
                  currentUser?.parcelRates === userPermissions.write) && (
                  <Route
                    path="/parcelRates"
                    element={<ParcelRates swalModal={swalModal} />}
                  />
                )}
              </>
            ) : null}
          </Routes>
        </div>

        <Footer />
        <ToastContainer />
      </div>
    </Router>
  );
}

export default App;
